import { H } from 'highlight.run';

export function identifyUser(args: { user; userSession }) {
  const { user, userSession } = args;
  const userAddress = userSession?.address;
  if (!user || !userSession || !userAddress) {
    return;
  }
  H.identify(userAddress, {
    // name: 'James Morrison',
    // email: 'jamesmorrison@example.com',
    address: userAddress,

    // Add your own custom user variables here, ie:
    // subscriptionType: 'pro'
  });
}
